import Layout from "modules/layout/dashboard"

import React from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { ReactComponent as EventIcon } from "assets/icons/event.svg"
import { ReactComponent as InvoiceIcon } from "assets/icons/invoice.svg"
import { ReactComponent as InboxIcon } from "assets/icons/inbox.svg"

import { useTranslation } from "react-i18next"

const { Main, Header } = Layout

const MemberLayout: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <Layout>
      <Header
        items={[
          {
            label: t("events.title"),
            key: "events",
            onClick: () => navigate("events"),
            icon: <EventIcon />,
          },
          {
            label: t("invoice.title"),
            key: "invoices",
            onClick: () => navigate("invoices"),
            icon: <InvoiceIcon />,
          },
          {
            label: t("discussion.title"),
            key: "discussion",
            onClick: () => navigate("discussion"),
            icon: <InboxIcon />,
          },
        ]}
      />
      <Main>
        <Outlet />
      </Main>
    </Layout>
  )
}

export default MemberLayout
